export default __webpack_public_path__ + "static/media/texas.7561954f.svg";